import { types } from "../Actions/types";

const initialState = {
  faqlist: [],
  error: null,
  faqSingle: "",
  popupmodel: "",
};

const Cms = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.FAQ_LIST:
      return {
        ...state,
        faqlist: payload,
        error,
      };
    case types.FAQ_SINGLE:
      return {
        ...state,
        faqSingle: payload,
        error,
      };
    case types.FAQ_FORM_MODEL:
      return {
        ...state,
        popupmodel: payload,
      };

    default:
      return state;
  }
};

export default Cms;
